module.exports = __webpack_public_path__ + "static/media/Yian Kut-Ku.9d6d6918.png";


//////////////////
// WEBPACK FOOTER
// ./src/eggs/images/Yian Kut-Ku.png
// module id = 148
// module chunks = 0